// extracted by mini-css-extract-plugin
export default {"visvial":"Visvial_visvial__5HMIH","left":"Visvial_left__Ip01K","wrapper":"Visvial_wrapper__7EkfY"};